import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ApplicationService } from '../../shared/services/application.service';
import { CommonService } from '../../shared/services/common.service';
import { Application, ChecklistInstance, CheckListValueModel, UserOrganization, Organization, FacilitySpecificProductItem } from '../../models/ApplicationModel';
import {
  FacilityType,
  OwnershipType,
  MLevel,
  MRLevel,
  QualificationType,
  ProfessionalType,
  RegionType,
  WoredaType,
  ZoneType,
  ProductType,
  SpecificProduct,
  ApplicationStatus,
  City, SpecificProductItem,
  DiplomaSelection, BranchOffice, FoodManufDoc, FIRItem, ApplicationCategory, SubCityType
} from '../../models/CommonModels';
import { AlertService } from '../../shared/services/alert.service';
import { FileUploader } from 'ng2-file-upload';
import { AccountService } from '../../services/account.service';
import { UserDto } from '../../models/User';
import { NumberValidator } from '../../validators/number.validator';
import { NO_SCRIPT_INPUT_MESSAGE, withNoScriptValidators } from '../../shared/validators/no-script-input.validator';
import { environment } from '../../../environments/environment';
import { Document, PaymentInfo, PaymentRequest } from '../../models/ApplicationModel';
import * as Constants from '../../models/Constants';
import {
  ApplicationDetail,
  DocumentDetail,
  DraftApplicationModel,
  DraftFacilityData,
} from '../../models/ApplicationDetail';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentRef } from '../../models/DocumentRef';
import { FileLikeObject } from 'ng2-file-upload';
import { NgxSpinnerService } from 'ngx-spinner';
import { ChecklistConfigModel, ChecklistItem } from '../../models/ChecklistModel';
import { SettingsService } from '../../shared/services/settings.service';
import {ProfessionalConfigFilter, ProfessionalTypeConfig} from '../../models/ProfessionalType';
import {ErisLoginService} from '../../services/sso/eris-login.service';
import { FacilityService } from '../../shared/services/facility.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

// const URL = '/api/';
const URL = environment.baseUrl + '/Attachment';
@Component({
  selector: 'app-create-application',
  templateUrl: './create-application.component.html',
  styleUrls: ['./create-application.component.css']
})

export class CreateApplicationComponent implements OnInit {

  @ViewChild('otherCity') otherCity;
  public draft: DraftApplicationModel;
  public tabList: Array<string> = ['facilityInfo', 'facilityLocation', 'facilityProfessionals', 'checklists', 'paymentMethod', 'fileAttachments'];
  public tab: string;
  public buttonName: string;
  public facilityTypes: FacilityType[];
  public productTypes: ProductType[];
  public ownershipTypes: OwnershipType[];
  public mLevels: MLevel[];
  public mRLevels: MRLevel[];
  public allmRLevels: MRLevel[];
  public professionalTypes: ProfessionalType[];

  public uploader: FileUploader;
  public user: UserDto;
  public showManufacturerMenu = false;
  public showFoodManufacturerMenu = false;
  public showErrors = false;
  public applicationForm: FormGroup;
  public editMode = false;
  public editingDraft = false;
  public documents: Array<Document>;
  public editDocuments: Array<DocumentDetail>;
  public documentRefs: Array<DocumentRef>;
  public restrictedDocRefCount: number;
  public applicationNumber: string;
  public applicationID: number;
  public recipetNumber: string;
  public showSpecificProductItem = false;
  public showSpecificProduct = true;
  public removeFieldValue = true;
  public appDetail: ApplicationDetail;
  public specificProducts: SpecificProduct[] = [];
  public appStatuses: ApplicationStatus[];
  public specificProductItems: SpecificProductItem[] = [];
  private regionTypes: RegionType[];
  private woredaTypes: WoredaType[];
  private subCityTypes: SubCityType[];
  private zoneTypes: ZoneType[];
  private branchList: BranchOffice[];
  private cities: City[];
  public draftApplicationID: number;

  private allowedFileType = ['pdf'];
  private maxFileSize: number = 6 * 1024 * 1024; // 6 MB
  private uploadErrorMessage: string;

  public constants: any = Constants;

  private checklistItems: Array<ChecklistInstance> = [];
  public checklists: ChecklistConfigModel[];
  public noChecklistAvailable = false;
  public productAndFacilityChanged = false;
  public paymentInfo: PaymentInfo;
  public smLetterOfExperienceDocRequired = true;
  public paymentMethodIndex = 5;
  public fileAttachmentIndex = 6;
  public showPayment = true;
  public tempCOC = false;
  public invalidTinNumber = false;
  public editableLegacyFields = {
    fields: []
  };
  public professionalTypeConfigList: ProfessionalTypeConfig[] = [];
  public ldeType = '';
  private fieldValue: null;
  public organizations : Organization[] = [];
  public selectedOrganization : Organization = null;
  public associatedOrgs : UserOrganization[] = [];
  public isFacilityNameEditable = false;
  public showSubCity = false;
  public selectedSpecificProductItems: FacilitySpecificProductItem[] = [];
  public specificProductItemForm : FormGroup;
  public modalRef: BsModalRef; 
  public modalTitle: string; 
  public indexOfSelectedSpecificProductItem: number = -1;
  public modalSpecificProductItems: SpecificProductItem[] = [];
  public paymentAmount: number;
  public telebirrPayingBillRef: string | null = null;
  /** Per-click chooser: '' = backend default, 'C2B' = H5 consumer instant pay, 'B2B' = H5 business. */
  public selectedTelebirrMode: string = environment.telebirrCheckoutMode || '';

  constructor(private fb: FormBuilder, private appService: ApplicationService, private commonService: CommonService, private router: Router,
              private alertService: AlertService, private accService: AccountService, private route: ActivatedRoute,
              private spinner: NgxSpinnerService, private settingsService: SettingsService,private erisLoginService: ErisLoginService, 
              private facilityService : FacilityService, private errorHandlerService: ErrorHandlerService, private modalService: BsModalService) {
    this.tempCOC = this.route.snapshot.params['temp'];
    if (this.tempCOC) {
      this.tabList = ['facilityInfo', 'facilityLocation', 'facilityProfessionals', 'fileAttachments'];
      this.fileAttachmentIndex = 4;
      this.noChecklistAvailable = true;
    }
    this.getFacilityTypes();
    this.getProductTypes();
    this.getOwnershipTypes();
    this.getmLevels();
    this.getmRLevels();
    this.getLocationTypes();
    this.getAppStatuses();
    this.getProfessionalTypes();
    this.getOrganizationApplicantAssociations();
  }


  ngOnInit() {
    // Wait until all the lookups are fetched

    this.uploader = new FileUploader({
      url: URL,
      allowedFileType: this.allowedFileType,
      maxFileSize: this.maxFileSize,
      headers: [{ name: 'Authorization', value: 'Bearer ' + this.accService.getTokenData() }]
    });
    this.uploader.onWhenAddingFileFailed = (item, filter, options) => this.onWhenAddingFileFailed(item, filter, options);

    this.tab = 'facilityInfo';
    this.buttonName = 'Next';
    this.user = this.accService.getUserData();
    this.initializeForm();

    const id = this.route.snapshot.params['id'];
    const mode = this.route.snapshot.params['mode'];
    this.ldeType = this.route.snapshot.queryParamMap.get('ldeType');
    if (id) {
      this.editMode = true;
      if (mode && mode === 'draft') {
        this.editingDraft = true;
        this.appService.getDraftApplication(id).subscribe(
          data => {
            this.draft = data;
            data.draftFacilityData = Object.assign(new DraftFacilityData(), JSON.parse(data.applicationJsonData));
            this.draftApplicationID = (new Number(data.id)).valueOf();
            this.appDetail = new ApplicationDetail(data.draftFacilityData, this.professionalTypes);
            this.appDetail.applicationCategory = data['applicationCategory'];
            this.tempCOC = this.appDetail.applicationCategory.applicationCategoryCode ===
              Constants.APPLICATION_TYPE_CODE_TEMP_COC;
            this.applicationNumber = this.appDetail.applicationNumber;
            this.recipetNumber = this.appDetail.recieptNumber;
            this.applicationID = this.appDetail.id;
            this.ldeType = data.draftFacilityData.ldeType;
            if (this.appDetail.paymentInfos.length) {
              this.paymentInfo = new PaymentInfo(this.appDetail.paymentInfos[this.appDetail.paymentInfos.length - 1]);
            }
            this.selectedSpecificProductItems = data.draftFacilityData.facilitySpecificProductItems || [];
            this.initializeEditForm(this.appDetail);
            this.removeFieldValue = false; // don't remove SP after loading it for edit the first time
            this.tinChanged(false);
            if (this.appDetail.isLegacyData) {
              this.fileAttachmentIndex = 4;
              this.applicationForm.removeControl('payment');
              this.showPayment = false;
            }

            if(this.paymentInfo && this.readServiceProvider(this.paymentInfo) != "CASH") {
              this.applicationForm.removeControl('payment');
              this.showPayment = false;
            } 

            this.editDocuments = this.appDetail.documents;
            if(this.tempCOC && !(this.appDetail.id)){//only barrier face mask for creating draft   
              this.productTypes = this.productTypes.filter(pt => pt.name.indexOf(Constants.PROUDCT_TYPE_BARRIER_FACE_MASK) > -1);
              this.facilityTypes = this.facilityTypes.filter(ft => ft.facilityTypeCode === 'MNFR' );
            }
            this.repopulateZoneAndWoredaList(this.appDetail.location.regionID, this.appDetail.location.zoneID, this.appDetail.location.subCityID);
          },
          err => {
            this.alertService.error(this.errorHandlerService.handleApiError(err));
          }
        );
      } else {
        this.appService.getApplication(id).subscribe(
          data => {

            this.appDetail = new ApplicationDetail(data, null);
            this.paymentMethodIndex = 5;
            this.fileAttachmentIndex = 6;
            this.applicationNumber = this.appDetail.applicationNumber;
            this.recipetNumber = this.appDetail.recieptNumber;
            this.applicationID = this.appDetail.id;
            if (this.appDetail.paymentInfos.length) {
              this.paymentInfo = new PaymentInfo(this.appDetail.paymentInfos[this.appDetail.paymentInfos.length - 1]);
            }
            
            this.selectedSpecificProductItems = data.facilitySpecificProductItems;
            this.initializeEditForm(this.appDetail);
            this.removeFieldValue = false; // don't remove SP after loading it for edit the first time
            this.tinChanged(false);
            this.findEditableLegacyFields();
            if (this.appDetail.isLegacyData) {
              this.fileAttachmentIndex = 4;
              this.applicationForm.removeControl('payment');
              this.showPayment = false;
            }       

            if(this.paymentInfo && this.readServiceProvider(this.paymentInfo) != "CASH") {
              this.applicationForm.removeControl('payment');
              this.showPayment = false;
            }

            if (this.isWithdrawnApplication()) {
              this.loadPaymentAmountForWithdrawnEdit();
            }

            this.repopulateZoneAndWoredaList(this.appDetail.location.regionID, this.appDetail.location.zoneID, this.appDetail.location.subCityID);
            this.editDocuments = this.appDetail.documents;
          },
          err => {
            this.alertService.error(this.errorHandlerService.handleApiError(err));
          }
        );
      }

    }
    this.documents = [];
    this.documentRefs = [];
  }

  retrievePaymentDetail(detail) {
    this.paymentInfo = detail;
    console.log('payment detail ', detail);
  }

  initializeForm() {
    this.applicationForm = this.fb.group({
      facility: this.fb.group({
        name: ['', Validators.required],
        ownerName: ['', Validators.required],
        ownerPhoneNumber: ['', [Validators.required, NumberValidator.isPhoneNumber]],
        facilityTypeID: ['', Validators.required],
        organizationTypeID: ['', Validators.required],
        productTypeID: ['', Validators.required],
        specificProductIDs: [[], Validators.required],
        specificProductItemIDs: [[]],
        mLevelID: ['', Validators.required],
        mrLevelID: ['', Validators.required],
        tinNumber: ['', [Validators.required]]
      }),
      location: this.fb.group({
        regionID: [-1, Validators.required],
        zoneID: [-1, Validators.required],
        subCityID: [-1],
        woredaID: [-1, Validators.required],
        cityID: [-1, Validators.required],
        kebele: [''],
        houseNo: ['', Validators.required],
        phoneNo: ['', [Validators.required, NumberValidator.isPhoneNumber]],
        areaName: ['', Validators.required],
        branchOfficeID: ['', Validators.required]
      }),
      professionals: this.fb.group({}),
      checklist: this.fb.group({}),
      paymentMethod: this.fb.group({
        method: ['CASH',  Validators.required]
      }),
      payment: this.fb.group({
        receiptNumber: ['', withNoScriptValidators([Validators.required])]
      })
    });
    if (this.tempCOC) {
      this.applicationForm.get('facility').get('mLevelID').clearValidators();
      this.applicationForm.get('facility').get('mrLevelID').clearValidators();
    }
  }

  initializeEditForm(applicationDetail: ApplicationDetail) {

    this.applicationForm = this.fb.group({
      facility: this.fb.group({
        name: [applicationDetail.facility.name, Validators.required],
        ownerName: [applicationDetail.facility.ownerName, Validators.required],
        ownerPhoneNumber: [applicationDetail.facility.ownerPhoneNumber, [Validators.required, NumberValidator.isPhoneNumber]],
        facilityTypeID: [applicationDetail.facility.facilityTypeID, Validators.required],
        organizationTypeID: [applicationDetail.facility.ownershipTypeID, Validators.required],
        productTypeID: [applicationDetail.productTypeID, Validators.required],
        specificProductIDs: [applicationDetail.specificProductIDs, Validators.required],
        specificProductItemIDs: [applicationDetail.specificProductItemIDs],
        mLevelID: [applicationDetail.mLevelID, Validators.required],
        mrLevelID: [applicationDetail.mrLevelID, Validators.required],
        tinNumber: [applicationDetail.facility.tinNumber, [Validators.required]]
      }),
      location: this.fb.group({
        regionID: [applicationDetail.location.regionID, Validators.required],
        zoneID: [applicationDetail.location.zoneID, Validators.required],
        subCityID: [applicationDetail.location.subCityID],
        woredaID: [applicationDetail.location.woredaID, Validators.required],
        cityID: [applicationDetail.location.cityID],
        kebele: [applicationDetail.location.kebele],
        houseNo: [applicationDetail.location.houseNo, Validators.required],
        phoneNo: [applicationDetail.location.phoneNo, [Validators.required, NumberValidator.isPhoneNumber]],
        areaName: [applicationDetail.location.areaName, [Validators.required]],
        branchOfficeID: [applicationDetail.branchOfficeID, Validators.required],
      }),
      professionals: this.fb.group({}),
      checklist: this.fb.group({}),
      paymentMethod: this.fb.group({
        method: ['CASH', [Validators.required]]
      }),
      payment: this.fb.group({
        receiptNumber: ['', withNoScriptValidators([Validators.required])]
      })
    });
    if (applicationDetail.paymentInfos.length) {
      const lastPaymentInfo = applicationDetail.paymentInfos[applicationDetail.paymentInfos.length - 1];
      this.applicationForm.get('payment').get('receiptNumber').setValue(lastPaymentInfo.recieptNumber);

      const existingMethod = this.readServiceProvider(lastPaymentInfo);
      if (existingMethod) {
        this.applicationForm.get('paymentMethod').get('method').setValue(existingMethod);
      }
    }
    if (this.tempCOC) {
      this.applicationForm.get('facility').get('mLevelID').clearValidators();
      this.applicationForm.get('facility').get('mrLevelID').clearValidators();
    }
  }

  activeTab(tab) {
    return this.tab === tab;
  }

  notFirstTab() {
    return !(this.getTabNumber() === 0);
  }

  nextClicked() {
    let index: number = this.getTabNumber();
    if (! (index === 5 || (this.tempCOC && index === 3))) { // next button
      if (index === 0 && (this.applicationForm.controls.facility.invalid || (this.showFoodManufacturerMenu && 
        !this.isSpecificProdItemTableValid() ))) {
        this.showErrors = true;
        console.log('facility ', this.applicationForm.controls.facility);
      } else if (index === 1 && this.applicationForm.controls.location.invalid) {
        this.showErrors = true;
      } else if (index === 2 && this.applicationForm.controls.professionals.invalid) {

        const invalid = [];
        const controls = this.applicationForm.controls.professionals['controls'];
        for (const name in controls) {
          if (controls[name].invalid) {
            invalid.push(name);
          }
          console.log('invalid ', invalid);
        }
        this.showErrors = true;
      } else if (index === 3 && this.isChecklistTabDisabled() && !this.tempCOC) {
        this.showErrors = true;
      } else if (index === 3 && this.applicationForm.controls.checklist.invalid && !this.tempCOC) {
        this.showErrors = true;
      } else {
        this.showErrors = false;
        if (index === 2 && (this.appDetail && (this.appDetail.isLegacyData || this.disableChecklistButtons()))) {
          this.tabClicked(this.tabList[index + 2]);
        } else {
          this.tabClicked(this.tabList[index + 1]);
        }
      }

    } else { // submit button
      if (this.editMode && !this.editingDraft) {
        this.editApplication(false);
      } else if (this.editMode && this.editingDraft) {

        if (this.appDetail.id) {
          this.editApplication(true);
        } else {
          this.createApplication();
        }
      } else {
        this.createApplication();
      }
    }
  }

  saveClicked() {
    this.spinner.show();

    const configuredProfessions = this.professionalTypeConfigList.map(pc => {
      return pc.professionalType.professionalTypeCode;
    });

    this.createChecklistObject();

    let appl = new Application(this.applicationForm.value, this.erisLoginService.getUserId(),
      configuredProfessions, this.checklistItems, this.appDetail, null);
    appl.applicationCategoryID = this.tempCOC ? 7 : 1;
    appl.documents = this.documents;

    // Same helper as edit/submit — createNew Save used to NRE when CASH and no receipt yet.
    this.applyPaymentMethodToPaymentInfo();
    appl.paymentInfos = [this.paymentInfo];

    if(this.showFoodManufacturerMenu){
      appl.facilitySpecificProductItems = this.selectedSpecificProductItems;
    }

    if (this.editMode && !this.editingDraft) {
      const id = this.route.snapshot.params['id'];
      appl.id = id;
      appl.applicationNumber = this.applicationNumber;
      appl.recieptNumber = this.recipetNumber;
      if (this.documents.length === 0) {
        for (let i = 0; i < this.editDocuments.length; i++) {
          appl.documents.push(new Document(this.editDocuments[i]));
        }
      }
      this.appDetail.paymentInfos[0] = this.paymentInfo;
      appl.paymentInfos = this.appDetail.paymentInfos;
      appl.applicationCategoryID = this.appDetail.applicationCategoryID;

      if (this.appDetail.applicationStatusCode === Constants.PRESCREENING_FAILED_CODE) {
        // after editing the status should change to ASDP
        appl.applicationStatusID = this.appStatuses.find(a => a.applicationStatusCode === Constants.CSO_ASSIGNED_CODE).id;
      } else if (this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED) {
        // after editing the status should change to FIS
        if (!appl.isLegacyData) {
          appl.applicationStatusID = this.appStatuses.find(a => a.applicationStatusCode === Constants.FI_SUBMITTED).id;
        } else {
          appl.applicationStatusID = this.appStatuses.find(a => a.applicationStatusCode === 'FIRS').id;
        }
        appl.editedFields = this.appDetail.editedFields;
      } else if(this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED_AFTER_INSPECTION) {
        appl.applicationStatusID = this.appStatuses.find(a => a.applicationStatusCode === Constants.FI_SUBMITTED_AFTER_INSPECTION).id;
        appl.editedFields = this.appDetail.editedFields;
      } else if (this.appDetail.applicationStatusCode === Constants.WITHDRAWN_CODE) {
        appl.applicationStatusID = this.resolveWithdrawEditStatusID(true);
      }
    }
    if (this.ldeType && this.ldeType !== '') {
      appl.ldeType = this.ldeType;
    }
    if (!this.draft) {
      this.draft = new DraftApplicationModel(JSON.stringify(appl), this.erisLoginService.getUserId());
      this.draft.applicationCatagoryID = appl.applicationCategoryID;
    } else {

      appl.id = this.applicationID;
      this.draft.applicationJsonData = JSON.stringify(appl);
      this.draft.createdBy = this.erisLoginService.getUserId();
    }
    this.appService.saveDraftApplication(this.draft).subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.alertService.success('Application saved as a draft Successfully');
        if (!this.draft.id) {
          this.draft.id = res.id;
        }
      } else {
        this.alertService.error('Unable to save your application as a draft!');
      }
    }, error => {
      this.spinner.hide();
      this.alertService.error(this.errorHandlerService.handleApiError(error));
    });
  }

  backClicked() {
    if (this.getTabNumber() === 4 && (this.appDetail && this.appDetail.isLegacyData || this.disableChecklistButtons())) {
      this.tabClicked(this.tabList[this.getTabNumber() - 2]);
    } else {
      this.tabClicked(this.tabList[this.getTabNumber() - 1]);
    }
  }

  getTabNumber() {
    let tabinput: string = this.tab;
    return this.tabList.findIndex(function (element: string) {
      return element === tabinput;
    });
  }

  getProductTypes(facilityTypeID = 0): void {
    this.commonService.getProductTypes(facilityTypeID, this.tempCOC).subscribe(resp => {
      this.productTypes = resp;
      if (this.tempCOC) {
        // only barrier face mask temporary coc creation is allowed, but can edit others
        if(!this.editMode || (this.editMode && this.editingDraft && !(this.appDetail.id))){
          this.productTypes = resp.filter( pt => pt.name.indexOf(Constants.PROUDCT_TYPE_BARRIER_FACE_MASK) > -1);
        } else {
          this.productTypes = resp.filter( pt => pt.name.indexOf('Med') > -1 || 
            pt.name.indexOf(Constants.PROUDCT_TYPE_BARRIER_FACE_MASK) > -1);
        }
        
      }
      const productTypeId = this.applicationForm !== null ? this.applicationForm.value.facility.productTypeID : null;
      if (productTypeId && !this.productTypes.find(x => x.id === productTypeId)) {
        this.applicationForm.get('facility').get('productTypeID').setValue('');
      }
    });
  }

  getFacilityTypes(): void {
    this.commonService.getFacilityTypes(true).subscribe(facilityTypes => {
      this.facilityTypes = facilityTypes;
      if (this.tempCOC) {
          if(!this.editMode || (this.editMode && this.editingDraft && !(this.appDetail.id))){
            this.facilityTypes = facilityTypes.filter(ft => ft.facilityTypeCode === 'MNFR' );
          } else {
            this.facilityTypes = facilityTypes.filter(ft =>
              ft.facilityTypeCode === 'IMPR' || ft.facilityTypeCode === 'MNFR' || ft.facilityTypeCode == 'WSLR');
          }
      }
    });
  }

  getOwnershipTypes(): void {
    this.commonService.getOwnershipTypes().subscribe(organizationTypes => this.ownershipTypes = organizationTypes);
  }

  getmLevels(): void {
    this.commonService.getMLevels().subscribe(mLevels => this.mLevels = mLevels);
  }

  getmRLevels(): void {
    this.commonService.getMRLevels().subscribe(mRLevels => {
      this.mRLevels = mRLevels;
      this.allmRLevels = mRLevels;
    }
    );
  }

  getAppStatuses() {
    this.commonService.getApplicationStatuses().subscribe(appStatuses => this.appStatuses = appStatuses);
  }

  getProfessionalTypes(): void {
    this.commonService.getProfessionalTypes().subscribe(professionalTypes => {
      this.professionalTypes = professionalTypes;
    });
  }

  get Constants() {
    return Constants;
  }

  getLocationTypes() {
    this.commonService.getRegionTypes().subscribe(regionTypes => {
      this.regionTypes = regionTypes;
    });
    this.commonService.getWoredaTypes().subscribe(woredaTypes => {
      this.woredaTypes = woredaTypes;
    });
    this.commonService.getZoneTypes().subscribe(zoneTypes => {
      this.zoneTypes = zoneTypes;
    });
    this.commonService.getCities().subscribe(cities => {
      this.cities = cities;
    });
    this.commonService.getSubCityTypes().subscribe(subCityTypes => {
      this.subCityTypes = subCityTypes;
    });
    this.commonService.getBranchOffices().subscribe(branches => {
      this.branchList = branches.map((branch) => {
        const cityName = branch.city ? branch.city.name : '';
        branch.label = branch.name + ' (' + cityName + ')'; return branch;
      });
    });
  }

  repopulateZoneAndWoredaList(regionID: number, zoneID: number, subCityID: number) {

    this.commonService.getZoneTypesByRegion(regionID).subscribe(zoneTypes => {
      this.zoneTypes = zoneTypes;
    });

    if(subCityID){
      this.commonService.getSubCityTypesByZone(zoneID).subscribe(subCityTypes => {
        this.subCityTypes = subCityTypes;
      });
      this.commonService.getWoredaTypesBySubCity(subCityID).subscribe(woredaTypes => {
        this.woredaTypes = woredaTypes;
      });
      this.showSubCity = true;
    } else {
      this.commonService.getWoredaTypesByZone(zoneID).subscribe(woredaTypes => {
        this.woredaTypes = woredaTypes;
      });
    }
  }

  tabClicked(tab) {
    this.tab = tab;
    if (tab === 'fileAttachments') {
      if (this.appDetail && this.appDetail.isLegacyData && this.ldeType === Constants.APPLICATION_TYPE_CODE_RENEWAL) {
        this.buttonName = 'Submit and Proceed to Renewal';
      }else if (this.appDetail && this.appDetail.isLegacyData && this.ldeType === Constants.APPLICATION_TYPE_CODE_CHANGE) {
        this.buttonName = 'Submit and Proceed to Change';
      } else {
        this.buttonName = 'Submit';
      }
      // check the check list response and add construction permit letter
      this.checkConstructionPermitLetterDocumentIsReq();
    } else {
      this.buttonName = 'Next';
    }
  }

  fetchConfiguredProfessionals() {
    this.professionalTypeConfigList = [];
    let professionalConfigFilter = new ProfessionalConfigFilter();
    professionalConfigFilter.applicationCategoryID = 1; // id for new application
    if (this.tempCOC) {
      professionalConfigFilter.applicationCategoryID = 7; // id for TCC
    }
    professionalConfigFilter.facilityTypeID = this.applicationForm.value.facility.facilityTypeID;
    professionalConfigFilter.productTypeID = this.applicationForm.value.facility.productTypeID;

    const product = this.productTypes.find(p => p.id === this.applicationForm.value.facility.productTypeID);
    if (product && [Constants.PRODUCT_TYPE_FOOD, Constants.PRODUCT_TYPE_COSMETICS].indexOf(product.name) !== -1) {
      // we dont want other manufacturers to send this values
      // cosmetics manufacturers don't have manufacturing risk level value so will not affect anything
      professionalConfigFilter.manufacturingRiskLevelID = this.applicationForm.value.facility.mrLevelID;
      professionalConfigFilter.manufacturingLevelID = this.applicationForm.value.facility.mLevelID;
    } 

    if (this.applicationForm.value.facility.specificProductItemIDs &&
      this.applicationForm.value.facility.specificProductItemIDs.length > 0) {
      professionalConfigFilter.specificProductItemIDs = this.applicationForm.value.facility.specificProductItemIDs;
    }

    if(this.showFoodManufacturerMenu && this.selectedSpecificProductItems.length > 0){
      professionalConfigFilter.specificProductItemIDs = this.selectedSpecificProductItems.map(s => s.specificProductItemID);
    }
    this.settingsService.getProfessionalConfigListForApplicant(professionalConfigFilter).subscribe( res => {
      this.professionalTypeConfigList = res;
      this.createProfessionalForm();
    }, err => {
      this.alertService.error(this.errorHandlerService.handleApiError(err));
    }, () => {

    });
  }

  createProfessionalForm() {
    Object.keys((this.applicationForm.get('professionals') as FormGroup).controls).forEach(key => {
      this.applicationForm.get('professionals').get(key).clearValidators();
      this.applicationForm.get('professionals').get(key).updateValueAndValidity();
    });

    if (!this.editMode) {
      this.professionalTypeConfigList.forEach(profConfig => {
        profConfig.professionalFieldConfig.filter(pfc => pfc.active).forEach( pf => {
          (this.applicationForm.get('professionals') as FormGroup).addControl(
            this.formatControlName(profConfig, pf),
            new FormControl(undefined, null));

          if (pf.required) {

            (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
              .setValidators(Validators.required);


              if (pf.professionalField.dataType === 'phoneNumber') {
                (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                  .setValidators([NumberValidator.isPhoneNumber, Validators.required]);
    
              } else if (pf.professionalField.dataType === 'email') {
                (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                  .setValidators([Validators.email, Validators.required]);
              }
              
              if (pf.professionalField.name === Constants.EXPERIENCE_LABEL) {
                (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                  .setValidators([Validators.min(0), Validators.required]);
              }

          } else {

            if (pf.professionalField.dataType === 'phoneNumber') {
              (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(NumberValidator.isPhoneNumber);
  
            } else if (pf.professionalField.dataType === 'email') {
              (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(Validators.email);
            }
            
            if (pf.professionalField.name === Constants.EXPERIENCE_LABEL) {
              (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(Validators.min(0));
            }
          }
          
        });
      });
    } else {
      const allProfessionals = this.appDetail.professionals[0];
      this.professionalTypeConfigList.forEach(profConfig => {
        profConfig.professionalFieldConfig.filter(pfc => pfc.active).forEach( pf => {

          this.fieldValue = allProfessionals[this.formatControlName(profConfig, pf)];
          let fieldValueExistsInLookup = true;

          if (pf.professionalField.professionalFieldCode === Constants.EDUCATION_LEVEL_CODE) {
            fieldValueExistsInLookup = Boolean(profConfig.educationLevelConfig.find(elc => elc.educationLevelID === this.fieldValue));
          }

          (this.applicationForm.get('professionals') as FormGroup).addControl(
            this.formatControlName(profConfig, pf),
            new FormControl(fieldValueExistsInLookup ? this.fieldValue : null, null));

          if (pf.required) {

            (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
              .setValidators(Validators.required);


              if (pf.professionalField.dataType === 'phoneNumber') {
                (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                  .setValidators([NumberValidator.isPhoneNumber, Validators.required]);
    
              } else if (pf.professionalField.dataType === 'email') {
                (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                  .setValidators([Validators.email, Validators.required]);
              }
              
              if (pf.professionalField.name === Constants.EXPERIENCE_LABEL) {
                (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                  .setValidators([Validators.min(0), Validators.required]);
              }

          } else {

            if (pf.professionalField.dataType === 'phoneNumber') {
              (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(NumberValidator.isPhoneNumber);
  
            } else if (pf.professionalField.dataType === 'email') {
              (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(Validators.email);
            }
            
            if (pf.professionalField.name === Constants.EXPERIENCE_LABEL) {
              (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(Validators.min(0));
            }
          }

        });
      });
    }


  }

  checkConstructionPermitLetterDocumentIsReq() {
    this.checklistItems = [];
    let controlArray = Object.keys(this.applicationForm.get('checklist')['controls']);
    const isFacPartiallyCompCheckList = this.checklists != undefined && this.checklists.find(ch => ch.checklist.description === Constants.CHECK_LIST_CONST_PARTIALLY_COMPLETED);
    if(isFacPartiallyCompCheckList && controlArray.findIndex(item => item === isFacPartiallyCompCheckList.checklist.id.toString()) !== -1){         
      if(this.applicationForm.get('checklist').get(isFacPartiallyCompCheckList.checklist.id.toString()).value.toString().toUpperCase() === 'YES'){       
        if(this.documentRefs.findIndex(dr => dr.name === Constants.CONSTRUCTION_PERMIT_LETTER_DOC.name) === -1){
          this.documentRefs.push(Constants.CONSTRUCTION_PERMIT_LETTER_DOC);
        }
      }else{
        this.removeConstructionPermitDocument();
      }
    }
  }

  removeConstructionPermitDocument() {
    let index = this.documentRefs.findIndex(dr => dr.name === Constants.CONSTRUCTION_PERMIT_LETTER_DOC.name);
    if (index !== -1) {
      this.documentRefs.splice(index, 1);
    }
  }

  isSubmitButtonDisabled() {
    let isSubmitButtonDisabled = false;
    switch (this.buttonName) {
      case 'Submit':
        if (this.appDetail && this.appDetail.isLegacyData) {
          isSubmitButtonDisabled = this.applicationForm.invalid || !this.checkAllRequiredDocsUploaded();

        } else {
          var paymentMethod = this.applicationForm.value.paymentMethod.method;
          // After Save, paymentInfo is always created — require a real cash receipt, not just a non-null object.
          const cashReceiptMissing = paymentMethod == 'CASH' && !(
            this.paymentInfo?.recieptNumber &&
            this.paymentInfo.recieptNumber !== 'PAYMENT_PENDING' &&
            this.paymentInfo?.documentID
          );
          isSubmitButtonDisabled = this.applicationForm.invalid || cashReceiptMissing || !this.checkAllRequiredDocsUploaded();
        }
        break;
      case  'Submit and Proceed to Renewal':
      case  'Submit and Proceed to Change':
        isSubmitButtonDisabled = this.applicationForm.invalid  || !this.checkAllRequiredDocsUploaded();
        break;
      default:
        break;
    }
    return isSubmitButtonDisabled;
  }

  createChecklistObject() {
    this.checklistItems = [];
    let controlArray = Object.keys(this.applicationForm.get('checklist')['controls']);

    for (let checklistControl of controlArray) {
      if (this.applicationForm.get('checklist').get(checklistControl).value.length) {
        const checklistRefIndex = this.checklists.findIndex(item => item.checklist.id.toString() === checklistControl);
        let newChecklistItem: ChecklistInstance = new ChecklistInstance();
        let checklistValue: CheckListValueModel = new CheckListValueModel();
        checklistValue.valueCode = this.applicationForm.get('checklist').get(checklistControl).value.toString().toUpperCase();
        checklistValue.name = this.applicationForm.get('checklist').get(checklistControl).value.toString();
        newChecklistItem.checkListValue = checklistValue;
        newChecklistItem.checklistID = this.checklists[checklistRefIndex].checklist.id;
        newChecklistItem.applicationID = this.appDetail ? this.appDetail.id : undefined;
        this.checklistItems.push(newChecklistItem);
      }
    }
  }

  createApplication() {
    this.spinner.show();
    const configuredProfessions = this.professionalTypeConfigList.map(pc => {
      return pc.professionalType.professionalTypeCode;
    });

    this.createChecklistObject();

    let appl = new Application(this.applicationForm.value, this.erisLoginService.getUserId(),
      configuredProfessions, this.checklistItems, null);
    appl.documents = this.documents;

    this.applyPaymentMethodToPaymentInfo();
    appl.paymentInfos = [this.paymentInfo];
    
    if(this.showFoodManufacturerMenu){
      appl.facilitySpecificProductItems = this.selectedSpecificProductItems;
      appl.facilitySpecificProductItems.forEach(element => {
        element.specificProductItem = null;
      });
    }

    this.appService.addApplication(appl, this.tempCOC).subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.alertService.success('Application Submitted Successfully');
        this.applicationForm.reset();
        this.uploader.clearQueue();
        if (this.editingDraft) {
          const id = this.route.snapshot.params['id'];
          this.appService.deleteDraftApplication(id).subscribe(res => {
            console.log('Draft version of the application has been discarded');
          }, err => {
            console.log('Unable to discard the draft version of the application');
            this.alertService.error('Unable to discard the draft version of the application');
          });
        }
        setTimeout(() => {
          this.router.navigateByUrl('/applications/list/' + res.id);
        }, 1000);
      } else {
        this.alertService.error('Unable to submit your application!');
      }
    },
      err => {
        this.spinner.hide();
        this.alertService.error(this.errorHandlerService.handleApiError(err));

      });
  }

  editApplication(editDraft: boolean) {
    let editableFields: string = editDraft ? null : JSON.stringify(this.editableLegacyFields);
    this.spinner.show();

    const configuredProfessions = this.professionalTypeConfigList.map(pc => {
      return pc.professionalType.professionalTypeCode;
    });
    this.createChecklistObject();
    // add the scrrenerResponseValue to the checkist instances -- important for FIR since editing is done after CSO adds the screener values
    this.checklistItems.forEach(item => {
       let checklistItem = this.appDetail.checkListInstances.find(i => i.checklistID === item.checklistID);
       item.screenerResponseValueID = checklistItem ? checklistItem.screenerResponseValueID : null;
       item.screenerResponseValue = checklistItem ? checklistItem.screenerResponseValue : null;
    });

    let appl = new Application(this.applicationForm.value, this.erisLoginService.getUserId(), configuredProfessions,
      this.checklistItems, this.appDetail, editableFields);
    if (!editDraft) {
      const id = this.route.snapshot.params['id'];
      appl.id = id;
    } else {
      appl.id = this.appDetail.id;
      appl.applicationStatusID = this.appDetail.applicationStatusID;
    }

    if(this.showFoodManufacturerMenu){
      appl.facilitySpecificProductItems = this.selectedSpecificProductItems;
      appl.facilitySpecificProductItems.forEach(element => {
        element.specificProductItem = null;
      });
    }

    appl.recieptNumber = this.recipetNumber;
    appl.applicationNumber = this.appDetail.applicationNumber;
    appl.documents = this.documents;
    this.applyPaymentMethodToPaymentInfo();
    if (this.appDetail.paymentInfos.length) {
      this.appDetail.paymentInfos[this.appDetail.paymentInfos.length - 1] = this.paymentInfo;
    } else {
      this.appDetail.paymentInfos = [this.paymentInfo];
    }
    appl.paymentInfos = this.appDetail.paymentInfos;
    if (this.appDetail.applicationStatusCode === Constants.PRESCREENING_FAILED_CODE) {
      // after editing the status should change to ASDP
      appl.applicationStatusID = this.appStatuses.find(a => a.applicationStatusCode === Constants.CSO_ASSIGNED_CODE).id;
    } else if (this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED) {
      // after editing the status should change to FIS
      if (!appl.isLegacyData) {
        appl.applicationStatusID = this.appStatuses.find(a => a.applicationStatusCode === Constants.FI_SUBMITTED).id;
      } else {
        appl.applicationStatusID = this.appStatuses.find(a => a.applicationStatusCode === 'FIRS').id;
      }
      appl.editedFields = this.appDetail.editedFields;
    } else if (this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED_AFTER_INSPECTION) {
      appl.applicationStatusID = this.appStatuses.find(a => a.applicationStatusCode === Constants.FI_SUBMITTED_AFTER_INSPECTION).id;
      appl.editedFields = this.appDetail.editedFields;
    } else if (this.appDetail.applicationStatusCode === Constants.WITHDRAWN_CODE) {
      appl.applicationStatusID = this.resolveWithdrawEditStatusID(false);
    }

    this.appService.editApplication(appl, this.tempCOC).subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.alertService.success('Application Edited Successfully');
        this.applicationForm.reset();
        this.uploader.clearQueue();
        if (editDraft) {
          this.appService.deleteDraftApplication(this.draftApplicationID).subscribe(res => {
            console.log('Draft version of the application has been discarded');
          }, err => {
            console.log('Unable to discard the draft version of the application');
            this.alertService.error('Unable to discard the draft version of the application');
          });
        }
        if (this.appDetail.isLegacyData && this.ldeType === Constants.APPLICATION_TYPE_CODE_RENEWAL) {
          this.router.navigateByUrl('/applications/createRenewal?facilityId=' + this.appDetail.facility.id);
        } else if (this.appDetail.isLegacyData && this.ldeType === Constants.APPLICATION_TYPE_CODE_CHANGE) {
          this.router.navigateByUrl('/applications/createChange?facilityId=' + this.appDetail.facility.id);
        } else {
          this.router.navigateByUrl('/applications/list/' + appl.id);
        }
      } else {
        this.alertService.error('Unable to edit your application!');
      }
    }, error => {
      this.spinner.hide();
      this.alertService.error(this.errorHandlerService.handleApiError(error));
    });
  }

  productOrFacilityChange() {
    const selectedFacilityType = this.applicationForm.value.facility.facilityTypeID;
    const productTypeId = this.applicationForm.value.facility.productTypeID;

    this.showManufacturerMenu = selectedFacilityType === Constants.MANUFACTURER_ID;
    this.showFoodManufacturerMenu = false;

    if (productTypeId && productTypeId !== '' && selectedFacilityType && selectedFacilityType !== '') {

      this.fetchConfiguredProfessionals();

      const product = this.productTypes.find(function (x) {
        return x.id === productTypeId;
      });

      const facilityType = this.facilityTypes.find(function (x) {
        return x.id === selectedFacilityType;
      });

      this.showSpecificProductItem =
        ([Constants.PRODUCT_TYPE_COSMETICS, Constants.PRODUCT_TYPE_SMALL_SCALE_COSMETICS,Constants.PRODUCT_TYPE_FOOD,
          Constants.PRODUCT_TYPE_MED_DEVICES].indexOf(product.name) !== -1) ||
        ([Constants.PRODUCT_TYPE_SMALL_SCALE_MEDICINE, Constants.PRODUCT_TYPE_MEDICINE,Constants.PRODUCT_TYPE_MEDICAL_GAS].indexOf(product.name) !== -1 && 
          [Constants.MANUFACTURER, Constants.IMPORTER].indexOf(facilityType.name) !== -1) ||
        ([Constants.PRODUCT_TYPE_MEDICINE, Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES, 
          Constants.PROUDCT_TYPE_BARRIER_FACE_MASK].indexOf(product.name) > -1 && this.tempCOC);

      this.commonService.getFilteredSpecificProducts(this.applicationForm.value.facility.facilityTypeID,
        this.applicationForm.value.facility.productTypeID).subscribe(specificProducts => {
        this.specificProducts = specificProducts;
        if (this.tempCOC && (product.name === Constants.PRODUCT_TYPE_SMALL_SCALE_MEDICINE || product.name === Constants.PRODUCT_TYPE_MEDICAL_GAS)) {
          this.specificProducts = this.specificProducts.filter(s => s.name.trim() === Constants.SP_ANTISEPTIC_DISENFECTANT ||
            s.name.trim() === Constants.SP_SMALL_SCALE_MED_DEVICE);
        } else if(product.name == Constants.PRODUCT_TYPE_MEDICINE && facilityType.name == Constants.MANUFACTURER){
          if(this.tempCOC){
            this.specificProducts = this.specificProducts.filter(s => s.name.trim() === Constants.SP_PHARM_MED_CHEMICALS);
          } else {
            this.specificProducts = this.specificProducts.filter(s => s.name.trim() !== Constants.SP_PHARM_MED_CHEMICALS);
          }
        } else if(product.name == Constants.PRODUCT_TYPE_MEDICINE && facilityType.name == Constants.IMPORTER){
          if(this.tempCOC){
            this.specificProducts = this.specificProducts.filter(s => s.name.trim() === Constants.SP_HUMAN_MED_SUPS);
          }
        }
      });

      this.applicationForm.get('facility').get('mrLevelID').clearValidators();

      if (this.removeFieldValue) {
        this.applicationForm.get('facility').get('specificProductIDs').setValue([]);
        this.applicationForm.get('facility').get('mrLevelID').setValue('');
      }

      if (product.name === Constants.PRODUCT_TYPE_FOOD && facilityType.name === Constants.MANUFACTURER)
      {
        this.applicationForm.get('facility').get('mrLevelID').setValidators([Validators.required]);
        this.showFoodManufacturerMenu = true;
      } 
      this.applicationForm.get('facility').get('mrLevelID').updateValueAndValidity();

      this.setSpecificProductValidator(product, facilityType);

      if ((this.appDetail && (this.appDetail.isLegacyData || this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED || 
          this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED_AFTER_INSPECTION)) || this.tempCOC) {
        this.noChecklistAvailable = true;
      } else {
        this.getCheckListConfig(selectedFacilityType, productTypeId);
      }
      this.productAndFacilityChanged = true;

      if(!this.isEditingExistingApplication()) {
        this.appService.getFirstTimeFee(1, selectedFacilityType, productTypeId).subscribe(resp => {
          this.paymentAmount = resp.data;
        })
      }
    }

    if (selectedFacilityType && selectedFacilityType === Constants.MANUFACTURER_ID && !this.tempCOC) {
      this.getProductTypes(selectedFacilityType);
      this.applicationForm.get('facility').get('mLevelID').setValidators([Validators.required]);
    } else {
      this.getProductTypes(selectedFacilityType);
      this.applicationForm.get('facility').get('mLevelID').clearValidators();
    }
    this.applicationForm.get('facility').get('mLevelID').updateValueAndValidity();

    if (productTypeId && selectedFacilityType && this.selectedOrganization) {
      this.repopulateRefList();
    }
  }

  spItemChange() {
    this.fetchConfiguredProfessionals();
  }

  spItemRemoved() {
    this.fetchConfiguredProfessionals();
  }

  isChecklistTabDisabled(): boolean {
    let disabled = true;
    if (this.productAndFacilityChanged) {
      disabled = this.noChecklistAvailable ?
        this.applicationForm.get('professionals').invalid : this.applicationForm.get('checklist').invalid;
    }
    return disabled || this.isFacilityProfessionalsTabDisabled();
  }

  fileAttachmentTabDisabled(): boolean {
    return !(this.appDetail && this.appDetail.isLegacyData && !this.applicationForm.controls.professionals.invalid)
      && this.isChecklistTabDisabled();
  }

  getCheckListConfig(selectedType, productTypeId) {
    const checklistFormGroup = this.applicationForm.get('checklist') as FormGroup;
    // Remove Previous Checklist Controls
    Object.keys(checklistFormGroup.controls).forEach(control => {
      checklistFormGroup.removeControl(control);
    });
    this.settingsService.getChecklistConfigForFacilityTypeProductTypeAppCategoryAndFacilityCategory(selectedType, productTypeId,
      1, null, null).subscribe(
        res => {
          let itemValue;
          if (res.length) {
            this.checklists = res.filter(c => c.active);
            this.checklists.forEach(item => {

              itemValue = this.returnFormValues(item);
              if (item.required) {
                checklistFormGroup.addControl(item.checklist.id.toString(), new FormControl(itemValue, [Validators.required]));
              } else {
                checklistFormGroup.addControl(item.checklist.id.toString(), new FormControl(itemValue));
              }
            });

            this.noChecklistAvailable = !this.checklists.length;

          } else {
            this.noChecklistAvailable = true;
          }
        }
      );
  }


  returnFormValues(item) {
    const checklistFormGroup = this.applicationForm.get('checklist') as FormGroup;
    if (this.editMode) {
      const idx = this.appDetail.checkListItems.findIndex(it => { return item.checklistID === it.checklistID; });
      if (idx > -1) {
        return this.appDetail.checkListItems[idx].checkListValue.name;
      }
    }
    return checklistFormGroup.get(item.checklist.id.toString()) ? checklistFormGroup.get(item.checklist.id.toString()).value : '';
  }


  repopulateRefList() {
    this.uploader.clearQueue();
    this.documents = [];
    const facilityTypeId = this.applicationForm.value.facility.facilityTypeID;
    const productTypeId = this.applicationForm.value.facility.productTypeID;
    let foodManDoc: FoodManufDoc = null;

    const facilityType = this.facilityTypes.find(f => f.id === this.applicationForm.value.facility.facilityTypeID);
    const productType = this.productTypes.find(p => p.id === this.applicationForm.value.facility.productTypeID);

    if (facilityType.name === Constants.MANUFACTURER && productType.name === Constants.PRODUCT_TYPE_FOOD) {

      foodManDoc = { mLevelID: this.applicationForm.value.facility.mLevelID, mRLevelID: this.applicationForm.value.facility.mrLevelID };

      if(!foodManDoc.mLevelID || !foodManDoc.mRLevelID){
        return;
      }
    }

    const focal = this.isApplicantFocalPerson();

    const organizationTypeID = this.applicationForm.value.facility.organizationTypeID;

    const selectedType = this.ownershipTypes.find(function (x) {
      return x.id === organizationTypeID;
    });
    if (!selectedType) {
      return;
    }
    
    this.isFacilityNameEditable = selectedType.organizationTypeCode === Constants.PRIVATE;
    const plc = (selectedType.organizationTypeCode === Constants.PLC);
    // fetch required docs
    let tempCOCAppCat = new ApplicationCategory();
    tempCOCAppCat.applicationCategoryCode = Constants.APPLICATION_TYPE_CODE_TEMP_COC;
    tempCOCAppCat.id = 7;
    this.appService.getDocumentRef(facilityTypeId, productTypeId, plc, focal,
      this.appDetail ? this.appDetail.applicationCategory : this.tempCOC ? tempCOCAppCat : null,
      null, foodManDoc).subscribe(
        documents => {
          this.documentRefs = documents;
          this.setRestrictedDocRefCount();
        }
      );

  }

  setRestrictedDocRefCount() {

    const restrictedDocs = this.documentRefs.filter(function (x) {
      return x.required === true;
    });
    const hasPaymentRef = restrictedDocs.filter(doc => { return doc.id === 35; }).length > 0;
    this.restrictedDocRefCount = restrictedDocs.length;

    if (this.appDetail) {
      return this.appDetail.isLegacyData && hasPaymentRef ? this.restrictedDocRefCount-- : null;
    }

  }


  riskLevelChange() {

    const mrLevel = this.mRLevels.find(x => x.id === this.applicationForm.value.facility.mrLevelID);

    if (!mrLevel) {
      return;
    }

    this.repopulateRefList();
    this.fetchConfiguredProfessionals();

  }

  manufacturingLevelChange() {

    const manufacturingLevel = this.mLevels.find(m => m.id === this.applicationForm.value.facility.mLevelID);
    if (!manufacturingLevel) {
      return;
    }
    if (manufacturingLevel.mLevelTypeCode !== Constants.HIGHER_MANUFACTURING) {
      this.mRLevels = this.allmRLevels.filter(mrl => mrl.mrLevelTypeCode !== Constants.MANUFACTURING_RISK_LEVEL_SPECIAL);
    }else {
      this.mRLevels = this.allmRLevels;
    }
    const facilityType = this.facilityTypes.find(f => f.id === this.applicationForm.value.facility.facilityTypeID);
    const productType = this.productTypes.find(p => p.id === this.applicationForm.value.facility.productTypeID);
    const mrLevel = this.mRLevels.find(x => x.id === this.applicationForm.value.facility.mrLevelID);

    if (facilityType.name === Constants.MANUFACTURER && productType.name === Constants.PRODUCT_TYPE_FOOD &&
      (manufacturingLevel.mLevelTypeCode !== Constants.HIGHER_MANUFACTURING ||
      (manufacturingLevel.mLevelTypeCode === Constants.HIGHER_MANUFACTURING &&
        mrLevel && mrLevel.mrLevelTypeCode === Constants.MANUFACTURING_RISK_LEVEL_LOW))) {
      this.repopulateRefList();
    }
    this.riskLevelChange();

    if(facilityType.name === Constants.MANUFACTURER && productType.name === Constants.PRODUCT_TYPE_COSMETICS){
      this.fetchConfiguredProfessionals();
    }
  }

  isApplicantFocalPerson() {
    let selectedTin =  this.selectedOrganization.tinNumber;
    let userOrg = this.associatedOrgs.find(ao => ao.tinNumber === selectedTin);
    return (userOrg.applicantType.applicationTypeCode === Constants.FOCAL_PERSON);
  }

  onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any) {
    switch (filter.name) {
      case 'fileSize':
        this.uploadErrorMessage = `Maximum upload size exceeded ( ${(item.size / (1024 * 1024)).toFixed(1)} MB uploaded,
         ${(this.maxFileSize / (1024 * 1024)).toFixed(1)} MB allowed)`;
        break;
      case 'fileType':
        const allowedTypes = this.allowedFileType.join();
        this.uploadErrorMessage = `Type '${item.type} is not allowed. Allowed types: '${allowedTypes}'`;
        break;
      default:
        this.uploadErrorMessage = `Unknown error (filter is ${filter.name})`;
    }
  }

  sortHierarchy = function (adminBoundary, source: string) {
    let selectedBoundaryID = adminBoundary !== null ? adminBoundary.id : -1;
    switch (source) {
      case 'regionID':
        this.commonService.getZoneTypesByRegion(selectedBoundaryID).subscribe(zoneTypes => {
          this.zoneTypes = zoneTypes;
        });
        break;
      case 'zoneID':
        if(adminBoundary.isCity){
          this.commonService.getSubCityTypesByZone(selectedBoundaryID).subscribe(subCityTypes => {
            this.subCityTypes = subCityTypes;
          });
        } else {
          this.commonService.getWoredaTypesByZone(selectedBoundaryID).subscribe(woredaTypes => {
            this.woredaTypes = woredaTypes;
          });
        }
        break;
      case 'subCityID':
        this.commonService.getWoredaTypesBySubCity(selectedBoundaryID).subscribe(woredaTypes => {
          this.woredaTypes = woredaTypes;
        });
        break;
      default:
        break;
    }
  };

  updateHierarchyLists(adminBoundary: any, source: string) {
    if (adminBoundary !== undefined) {
      switch (source) {

        case 'regionID':
          adminBoundary = <RegionType>adminBoundary;
          this.applicationForm.controls.location['controls'].zoneID.setValue(null);
          this.applicationForm['controls'].location['controls'].woredaID.setValue(null);
          this.sortHierarchy(adminBoundary, source);
          this.woredaTypes = [];
          break;
        case 'zoneID':
          adminBoundary = <ZoneType>adminBoundary;
          this.showSubCity = adminBoundary.isCity ? true : false;
          if(adminBoundary.isCity){         
            this.applicationForm.get('location').get('subCityID').setValidators([Validators.required]);      
          } else {
            this.applicationForm.get('location').get('subCityID').clearValidators();
          }
          this.applicationForm['controls'].location['controls'].woredaID.setValue(null);
          this.applicationForm['controls'].location['controls'].subCityID.setValue(null);
          this.applicationForm.get('location').get('subCityID').updateValueAndValidity();
          this.sortHierarchy(adminBoundary, source);
          break;
        case 'subCityID':
          adminBoundary = <ZoneType>adminBoundary;
          this.applicationForm['controls'].location['controls'].woredaID.setValue(null);
          this.sortHierarchy(adminBoundary, source);
          break;
      }
    }
  }

  specificProductChanges(editMode) {
    if (this.applicationForm.value.facility.specificProductIDs.indexOf(0) !== -1) {
      // This means 'Other' is selected, so we remove the selected specific products
      this.applicationForm.get('facility').get('specificProductIDs').setValue([0]);
    }

    if (!editMode) {
      let allowedSPItems = this.specificProductItems.filter(item =>
        this.applicationForm.value.facility.specificProductIDs.indexOf(item.specificProductID) !== -1).map(item => item.id);
      this.applicationForm.get('facility').get('specificProductItemIDs')
        .setValue(this.applicationForm.value.facility.specificProductItemIDs.filter(item => allowedSPItems.indexOf(item) !== -1));
    }

    this.commonService.getFilteredSpecificProductItems(this.applicationForm.value.facility.specificProductIDs)
      .subscribe(specificProductItems => {
        this.specificProductItems = specificProductItems;
        let medicineSPItems = [Constants.SP_ITEM_ALCOHOL_BASED_HAND_RUB, Constants.SP_ITEM_DISNFECTANT_SURFACE];
        let medDevSpItems = [Constants.SP_ITEM_APRON, Constants.SP_ITEM_FACE_SHIELDS,Constants.SP_ITEM_GLOVES_NON_STERILE, 
          Constants.SP_ITEM_GLOVES_STERILE, Constants.SP_ITEM_GOOGLES,Constants.SP_ITEM_COVER_GOWN,Constants.SP_ITEM_SHOE_COVER,
          Constants.SP_ITEM_STERILE_MEDICAL_MASK, Constants.SP_ITEM_NON_STERILE_MEDICAL_MASK, Constants.SP_ITEM_RESPIRATOR, Constants.SP_ITEM_LAB_SCREENING_KIT,
          Constants.SP_ITEM_LAB_CONFIRMATION_KIT, Constants.SP_ITEM_RT_PCR_KIT,Constants.SP_ITEM_EXTRACTION_KIT, Constants.SP_ITEM_CARTRIDGES,
          Constants.SP_ITEM_SWAB, Constants.SP_ITEM_PULSE_OXIMETER,Constants.SP_ITEM_CONCENTRATOR, Constants.SP_ITEM_NASAL_OXYGEN_CANNULA,
          Constants.SP_ITEM_VENTILATOR_PATIENT, Constants.SP_ITEM_IR_THERMOMETER,Constants.SP_ITEM_CPAP,Constants.SP_ITEM_SUCTION_PUMP,
          Constants.SP_ITEM_HIGH_FLOW_NASAL_CANNULA, Constants.SP_ITEM_MEDICAL_MASK, Constants.SP_ITEM_COVID_TEST_KIT];
        let medAndMedDevSpItems = medicineSPItems.concat(medDevSpItems);

        if (this.tempCOC) {
          const productTypeId = this.applicationForm.value.facility.productTypeID;
          const productType = this.productTypes.find(x => x.id === productTypeId);

          if (productType.name === Constants.PRODUCT_TYPE_MEDICINE) {
            this.specificProductItems = this.specificProductItems.filter(s => medicineSPItems.indexOf(s.name.trim()) !== -1);
          } else if (productType.name === Constants.PRODUCT_TYPE_MED_DEVICES) {
            this.specificProductItems = this.specificProductItems.filter(s => medDevSpItems.indexOf(s.name.trim()) !== -1);
          } else if (productType.name === Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES) {
            this.specificProductItems = this.specificProductItems.filter(s => medAndMedDevSpItems.indexOf(s.name) !== -1);
          }
        }else {
          // we don't want to see specific product items created for temp coc to show in New application
          this.specificProductItems = this.specificProductItems.filter(s => medAndMedDevSpItems.indexOf(s.name.trim()) === -1);
        }
      });

  }

  addOtherCity() {
    let otherCityName = this.otherCity.nativeElement.value;
    if (otherCityName === '') {
      return;
    }
    let existingCity = this.cities.find(c => c.name.trim().toLowerCase() === otherCityName.trim().toLowerCase());
    if (existingCity !== undefined) {
      this.applicationForm.get('location').get('cityID').setValue(existingCity.id);
      return;
    }
    const city = new City();
    city.name = otherCityName;
    this.commonService.addCity(city).subscribe(
      resp => {
        this.commonService.getCities().subscribe(
          cities => {
            this.cities = cities;
            let newEltId = this.cities.find(c => c.name === otherCityName).id;
            this.applicationForm.get('location').get('cityID').setValue(newEltId);
          });
      });
  }

  setSpecificProductValidator(productType, facilityType) {
    if (!this.tempCOC && ((facilityType.name != Constants.MANUFACTURER  && facilityType.name != Constants.IMPORTER && productType.name == Constants.PRODUCT_TYPE_MEDICINE) || 
          productType.name == Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES)) {
      this.showSpecificProduct = false;
      this.applicationForm.get('facility').get('specificProductIDs').clearValidators();
      this.applicationForm.get('facility').get('specificProductIDs').updateValueAndValidity();
      this.applicationForm.get('facility').get('specificProductIDs').setValue([]);
    } else {
      this.showSpecificProductItem ?
        this.applicationForm.get('facility').get('specificProductItemIDs').setValidators([Validators.required]) :
        this.applicationForm.get('facility').get('specificProductItemIDs').clearValidators();

      this.applicationForm.get('facility').get('specificProductItemIDs').updateValueAndValidity();
      this.showSpecificProduct = true;
      this.applicationForm.get('facility').get('specificProductIDs').setValidators([Validators.required]);
      this.applicationForm.get('facility').get('specificProductIDs').updateValueAndValidity();
    }

    // food manufacturers will use the specific product item table instead of multiple select field
    if (productType.name === Constants.PRODUCT_TYPE_FOOD && facilityType.name === Constants.MANUFACTURER)
    {
      this.applicationForm.get('facility').get('specificProductItemIDs').clearValidators();
      this.applicationForm.get('facility').get('specificProductItemIDs').updateValueAndValidity();
    } 
    
  }

  checkAllRequiredDocsUploaded() {

    let reqDocumentsCount = 0;

    this.documents.forEach(element => {

      if (element.referenceID !== null) {

       let index =  this.documentRefs.findIndex(dr => dr.id === element.referenceID);

       if (index !== -1) {
         return this.documentRefs[index].required ? reqDocumentsCount++ : null;
       }

      }
    });

    // if Medicine, Medical Device or Medicine and Medical Device is selected as a product type
    // and Pharmascist is selected for Store Manager qualification
    // the 'Experience Letter for Store Manager' document will be Optional
    const product = this.productTypes.find(p => p.id === this.applicationForm.value.facility.productTypeID);
    if (!this.tempCOC && product !== undefined && [Constants.PRODUCT_TYPE_MEDICINE, Constants.PRODUCT_TYPE_MED_DEVICES,
    Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES].indexOf(product.name) !== -1) {
      const smConfig = this.professionalTypeConfigList.find(pc => pc.professionalType.professionalTypeCode === Constants.STORE_MANAGER_CODE);
      if(smConfig){
        const eduConfig = smConfig.educationLevelConfig.find(ec => ec.educationLevelID == this.applicationForm.value.professionals.smEducationLevelID);
        const quaConfig = eduConfig.qualificationConfig.find(qc => qc.qualificationID === this.applicationForm.value.professionals.smQualificationID);
        if (quaConfig !== undefined && quaConfig.qualification.name === Constants.PHARMACIST) {
          const docRef = this.documentRefs.find(d => d.name === Constants.EXPERIENCE_LETTER_STORE_MANAGER_DOC);
          if (docRef !== undefined && docRef.required) {
            return this.documents.length >= (this.restrictedDocRefCount - 1);
          }
        }
      }
    }
    return reqDocumentsCount >= this.restrictedDocRefCount;
  }

  inputIsDisabled(inputValue, controlGroup, controlName) {
    if (this.appDetail) {
      if (this.appDetail.isLegacyData && inputValue) {
        if (this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED) {
          let editFields: FIRItem[] = JSON.parse(this.appDetail.editedFields);
          let groupIndex = editFields.findIndex(item => item.name === controlGroup);

          if (groupIndex === -1) {
            return inputValue.valid;
          }
          return inputValue.valid && editFields[groupIndex].subItems.findIndex(item => item.name === controlName) === -1;
        }
      return  !(inputValue.value === null || inputValue.value === '' || inputValue.value === undefined ||
          (inputValue.value['length'] !== undefined && inputValue.value.length === 0)) &&
        !inputValue.dirty;
      } else if (this.appDetail.applicationCategory &&
        (this.appDetail.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_NEW  ||
        this.appDetail.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_COC) &&
        (this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED || this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED_AFTER_INSPECTION)) {
          let editFields: FIRItem[] = JSON.parse(this.appDetail.editedFields);
          let groupIndex = editFields.findIndex(item => item.name === controlGroup);
        if (groupIndex === -1) {
          return inputValue ? inputValue.valid : true;
        }

        return inputValue ? inputValue.valid && editFields[groupIndex].subItems.findIndex(item => item.name === controlName) === -1 :
          editFields[groupIndex].subItems.findIndex(item => item.name === controlName) === -1;
      }
    }
    return false;
  }

  getFIRDocumentRefs() {

    if (!this.appDetail || !(this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED || this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED_AFTER_INSPECTION)) {
      return undefined;
    }

    let editFields: FIRItem[] = JSON.parse(this.appDetail.editedFields);


        let groupIndex = editFields.findIndex(item => item.name === 'Documents');

        if (groupIndex === -1) {
          return new FIRItem();
        } else {
          return editFields[groupIndex];
        }
  }

  findEditableLegacyFields() {
    let formGroups = Object.keys(this.applicationForm.controls);
    formGroups.forEach(formGroup => {
      let controls = Object.keys(this.applicationForm.controls[formGroup]['controls']);
      controls.forEach(control => {
        console.log(this.applicationForm.controls[formGroup]['controls'][control]);
        if (!this.inputIsDisabled(this.applicationForm.controls[formGroup]['controls'][control], null, null)) {
          this.editableLegacyFields.fields.push(control);
        }
      });
    });
    if (this.editableLegacyFields.fields.indexOf('areaName') === -1) {
      this.editableLegacyFields.fields.push('areaName');
    }
  }

  fieldHighlighted(controlGroup, controlName) {
    return { 'input-highlight': this.appDetail && (this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED 
      || this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED_AFTER_INSPECTION) && !this.inputIsDisabled(null, controlGroup, controlName) };
  }

  disableChecklistButtons() {
    return (this.appDetail && this.appDetail.applicationCategory &&
      this.appDetail.applicationCategory.name === Constants.APPLICATION_TYPE_NAME_NEW &&
      (this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED || this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED_AFTER_INSPECTION));
  }

  saveNotAllowed() {
    return (this.appDetail && this.appDetail.applicationCategory &&
      (this.appDetail.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_NEW ||
      this.appDetail.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_COC) &&
      (this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED || this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED_AFTER_INSPECTION));
  }

  formatControlName(profTypeConfig, field) {
    return profTypeConfig.professionalType.professionalTypeCode.toLowerCase() + field.professionalField.name.replace(/ /g, '')
    + (field.professionalField.dataType === 'lookup' ? 'ID' : '');
  }

  onStoreManagerQualificationChange(pharmacistSelected: boolean) {
    if (pharmacistSelected) {
      const product = this.productTypes.find(p => p.id === this.applicationForm.value.facility.productTypeID);
      if ([Constants.PRODUCT_TYPE_MEDICINE, Constants.PRODUCT_TYPE_MED_DEVICES,
      Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES].indexOf(product.name) !== -1) {
        this.smLetterOfExperienceDocRequired = false;
      }
    } else {
      this.smLetterOfExperienceDocRequired = true;
    }
  }

  onDiplomaSelection(data: DiplomaSelection) {
    const product = this.productTypes.find(p => p.id === this.applicationForm.value.facility.productTypeID);
    const facility = this.facilityTypes.find(f => f.id === this.applicationForm.value.facility.facilityTypeID);

    if (product.name !== Constants.PRODUCT_TYPE_FOOD || facility.name !== Constants.MANUFACTURER) {
      return;
    }

    let index = -1;

    switch(data.educationLevelInput)
    {
      case 'pmEducationLevelID':
        index = this.documentRefs.findIndex(d => d.name === Constants.PM_EXPERIENCE_DOCUMENT);
        break;
      case 'qaEducationLevelID':
        index = this.documentRefs.findIndex(d => d.name === Constants.QA_EXPERIENCE_DOCUMENT);
        break;
      case 'hseEducationLevelID':
        index = this.documentRefs.findIndex(d => d.name === Constants.HS_EXPERIENCE_DOCUMENT);
        break;
      case 'pceEducationLevelID':
        index = this.documentRefs.findIndex(d => d.name === Constants.PSE_EXPERIENCE_DOCUMENT);
        break;
      case 'mbEducationLevelID':
        index = this.documentRefs.findIndex(d => d.name === Constants.MB_EXPERIENCE_DOCUMENT);
        break;
      case 'qcEducationLevelID':
        index = this.documentRefs.findIndex(d => d.name === Constants.QC_EXPERIENCE_DOCUMENT);
        break;
    }

    if(index != -1)
    {
      this.documentRefs[index].required = data.diplomaSelected;
      this.setRestrictedDocRefCount();
    }
  }
  
  getOrganizationApplicantAssociations(){
    this.facilityService.getOrganizationApplicantAssociations().subscribe(resp => {
      let user = this.accService.getUserData();
      this.associatedOrgs = resp.filter(r => r.userID === user.id);
      this.organizations = this.associatedOrgs.map(r => r.organization);
      if(this.applicationForm){   
        this.tinChanged(false);     
      }
    });
  }

  tinChanged(userTriggered: boolean){
    let selectedTin = this.applicationForm.value.facility.tinNumber;
    this.selectedOrganization = this.organizations.find(o => o.tinNumber === selectedTin);
    if(this.selectedOrganization){
      if(userTriggered){
        this.setOwnershipInfoFromOrganization(this.selectedOrganization);
      }
      this.productOrFacilityChange();   
      this.specificProductChanges(true);
      this.manufacturingLevelChange();
      this.removeFieldValue = true;
    }
  }

  setOwnershipInfoFromOrganization(organization: Organization){
    this.applicationForm.get('facility').get('name').setValue(organization.name);
    this.applicationForm.get('facility').get('organizationTypeID').setValue(organization.organizationTypeID);
    this.applicationForm.get('facility').get('ownerName').setValue(organization.ownerName);
    this.applicationForm.get('facility').get('ownerPhoneNumber').setValue(organization.ownerPhone);
  }

  addSpecificProductItemClicked(template) {
    this.specificProductItemForm = this.fb.group({
      specificProductItemID: ['', Validators.required],
    });

    const spids = this.selectedSpecificProductItems.map(spi => spi.specificProductItemID);
    this.modalSpecificProductItems = this.specificProductItems.filter(spi => spids.indexOf(spi.id) === -1);
    this.modalTitle = "Add Specific Product Item";
    this.modalRef = this.modalService.show(template);
  }

  editSpecificProductItemClicked(template, index) {
    this.indexOfSelectedSpecificProductItem = index;
    
    const specificProdItem = this.selectedSpecificProductItems[index];
    this.specificProductItemForm = this.fb.group({
      specificProductItemID: [specificProdItem.specificProductItemID, Validators.required],
    });

    const spids = this.selectedSpecificProductItems.map(spi => spi.specificProductItemID).filter(id => id !== specificProdItem.specificProductItemID);
    this.modalSpecificProductItems = this.specificProductItems.filter(spi => spids.indexOf(spi.id) === -1);
    this.modalTitle = "Edit Specific Product Item";
    this.modalRef = this.modalService.show(template);
  }

  deleteSpecificProductItemModal(template, index){
    this.indexOfSelectedSpecificProductItem = index;
    this.modalRef = this.modalService.show(template);
  }

  specificProductItemModalCancelClicked(){
    this.closeSpecificProductItemModal();
  }

  specificProductItemModalSaveClicked(){
    if(this.indexOfSelectedSpecificProductItem !== -1) { //editing
      this.selectedSpecificProductItems.splice(this.indexOfSelectedSpecificProductItem, 1);
    }

    const formData = this.specificProductItemForm.value;
    let specificProdItemData = new FacilitySpecificProductItem(formData.specificProductItemID);
    specificProdItemData.specificProductItem = this.specificProductItems.find(spi => spi.id == formData.specificProductItemID);
    this.selectedSpecificProductItems.push(specificProdItemData);
    this.closeSpecificProductItemModal();
    this.fetchConfiguredProfessionals();
  }
  
  closeSpecificProductItemModal() {
    this.indexOfSelectedSpecificProductItem = -1;
    this.modalRef.hide();
  }

  deleteSpecificProductItem(){
    this.selectedSpecificProductItems.splice(this.indexOfSelectedSpecificProductItem, 1);
    this.closeSpecificProductItemModal();
    this.fetchConfiguredProfessionals();
  }

  isSpecificProdItemTableValid() {
    return this.selectedSpecificProductItems.length > 0;
  }

  isFacilityAddressTabDisabled() {
    return this.applicationForm.controls.facility.invalid || (this.showFoodManufacturerMenu && !this.isSpecificProdItemTableValid());
  }

  isFacilityProfessionalsTabDisabled() {
    return this.isFacilityAddressTabDisabled() || (this.applicationForm.controls.location.invalid || !this.professionalTypeConfigList || !this.professionalTypeConfigList.length);
  }

  isSpecificProductItemTableFIRDisabled() {
    if(this.appDetail && this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED){    
      let editFields: FIRItem[] = JSON.parse(this.appDetail.editedFields);
      let groupIndex = editFields.findIndex(item => item.name === 'Facility Information');
      if(groupIndex == -1){
        return this.isSpecificProdItemTableValid();
      }

      return this.isSpecificProdItemTableValid() && editFields[groupIndex].subItems.findIndex(item => item.name === 'Specific Product Item') === -1;
    }

    return false;
  }

  onPaymentMethodChange(event) {
    const selectedPaymentMethod = event.target.value;
    if(selectedPaymentMethod == "CASH") {
      this.showPayment = true;
      const existingReceiptNumber = this.paymentInfo?.recieptNumber && this.paymentInfo.recieptNumber !== 'PAYMENT_PENDING'
        ? this.paymentInfo.recieptNumber
        : '';
      this.applicationForm.addControl('payment', this.fb.group({
        receiptNumber: [existingReceiptNumber, withNoScriptValidators([Validators.required])]
      }));
    } else {
      this.applicationForm.removeControl('payment');
      this.showPayment = false;
    }
  }

  isEditingExistingApplication() {
    return (this.editMode && !this.editingDraft) || (this.editMode && this.editingDraft && this.appDetail.id);
  }

  isWithdrawnApplication() {
    return this.appDetail && this.appDetail.applicationStatusCode === Constants.WITHDRAWN_CODE;
  }

  // For a withdrawn application being edited:
  //   - Draft save only: if payment is already paid, method unchanged, and amount unchanged,
  //     keep WITH so a partial edit does not re-enter the workflow.
  //   - Submit: always reopen the workflow → RQST (Requested), same as a new application.
  //     Telebirr/CBE unpaid state is tracked on PaymentInfo (PAYMENT_PENDING), not a separate status.
  // Falls back to the existing status if the target lookup is missing from appStatuses.
  private resolveWithdrawEditStatusID(forDraft: boolean): number {
    if (forDraft) {
      const noPaymentEdit = this.isExistingPaymentPaid()
        && this.isMethodSameAsExisting()
        && !this.hasAmountChangedFromExisting();
      if (noPaymentEdit) {
        return this.appDetail.applicationStatusID;
      }
    }

    const selectedMethod = (this.applicationForm?.value?.paymentMethod?.method || '').toUpperCase();
    let targetCode = Constants.REQUESTED_CODE;
    if (forDraft && selectedMethod !== 'CASH') {
      targetCode = Constants.PENDING_PAYMENT;
    }

    let target = this.appStatuses?.find(a => a.applicationStatusCode === targetCode);
    if (!target && targetCode === Constants.PENDING_PAYMENT) {
      target = this.appStatuses?.find(a => a.applicationStatusCode === Constants.REQUESTED_CODE);
    }
    return target ? target.id : this.appDetail.applicationStatusID;
  }

  isPaymentMethodLocked() {
    return this.isEditingExistingApplication() && !this.isWithdrawnApplication();
  }

  getCurrentPaymentInfo(): any {
    if (!this.appDetail || !this.appDetail.paymentInfos || !this.appDetail.paymentInfos.length) {
      return null;
    }
    return this.appDetail.paymentInfos[this.appDetail.paymentInfos.length - 1];
  }

  getExistingServiceProvider(): string {
    return this.readServiceProvider(this.getCurrentPaymentInfo());
  }

  // Backend serializes JSON responses as camelCase but request bodies built in this
  // component still use PascalCase keys, so existing PaymentInfo objects can carry
  // either casing depending on whether they came from the server or were just edited.
  private readServiceProvider(paymentInfo: any): string {
    return paymentInfo?.payment?.serviceProvider || paymentInfo?.payment?.ServiceProvider || paymentInfo?.paymentMethod || 'CASH';
  }

  isMethodSameAsExisting(): boolean {
    const selectedMethod = this.applicationForm?.value?.paymentMethod?.method;
    return !!selectedMethod && selectedMethod === this.getExistingServiceProvider();
  }

  getExistingBillReferenceNumber(): string | null {
    const pi = this.getCurrentPaymentInfo();
    return pi?.payment?.billReferenceNumber || pi?.payment?.BillReferenceNumber || null;
  }

  getExistingPaymentAmount(): number {
    const pi = this.getCurrentPaymentInfo();
    const amount = pi?.payment?.amount ?? pi?.payment?.Amount;
    return amount ?? this.paymentAmount;
  }

  hasExistingBillForSelectedMethod(): boolean {
    return this.isMethodSameAsExisting() && !!this.getExistingBillReferenceNumber();
  }

  // True only when there is an existing bill for the currently-selected method AND the
  // freshly-recalculated payment amount differs from what was charged on the existing bill.
  // Telebirr/CBE bills are tied to a specific amount on the gateway side, so we must NOT
  // let the user re-pay an amount-mismatched bill — they must save first so the backend
  // regenerates the bill (UpdatePaymentAsync handles this when amountChanged === true).
  hasAmountChangedFromExisting(): boolean {
    if (!this.hasExistingBillForSelectedMethod()) {
      return false;
    }
    const existing = Number(this.getExistingPaymentAmount());
    const fresh = Number(this.paymentAmount);
    if (!isFinite(existing) || !isFinite(fresh) || existing <= 0 || fresh <= 0) {
      return false;
    }
    return existing !== fresh;
  }

  // For non-CASH withdraw flows: only allow re-paying the existing bill when nothing
  // material has changed (same method, amount unchanged, not yet paid).
  canRepayExistingBill(): boolean {
    return this.isWithdrawnApplication()
      && this.hasExistingBillForSelectedMethod()
      && !this.isExistingPaymentPaid()
      && !this.hasAmountChangedFromExisting();
  }

  isExistingPaymentPaid(): boolean {
    const pi = this.getCurrentPaymentInfo();
    if (!pi) {
      return false;
    }
    const statusName = pi.payment?.status?.name || pi.payment?.Status?.name;
    if (statusName && statusName.toLowerCase() === 'completed') {
      return true;
    }
    return !!pi.recieptNumber && pi.recieptNumber !== 'PAYMENT_PENDING';
  }

  isTelebirrPaymentInProgress(billReferenceNumber: string): boolean {
    const ref = (billReferenceNumber ?? '').trim();
    return !!ref && this.telebirrPayingBillRef === ref;
  }

  initiatePayment(price: number, billReferenceNumber: string) {
    const ref = (billReferenceNumber ?? '').trim();
    if (!ref) {
      this.alertService.error('Bill reference is missing. Please save the application first to generate a bill.');
      return;
    }
    if (this.isTelebirrPaymentInProgress(ref)) {
      this.alertService.info('Payment on progress. Complete payment in the Telebirr window, then refresh this page.');
      return;
    }
    const request = new PaymentRequest();
    request.title = 'EFDA Payment';
    request.amount = price;
    request.billReferenceNumber = ref;
    // Per-click chooser wins; falls back to env build default; empty = let the backend decide.
    const resolvedMode = (this.selectedTelebirrMode || environment.telebirrCheckoutMode || '').trim();
    if (resolvedMode) {
      request.checkoutMode = resolvedMode;
    }

    this.telebirrPayingBillRef = ref;
    this.spinner.show();
    this.appService.createTelebirrOrder(request).subscribe(
      res => {
        this.spinner.hide();
        if (res?.rawRequest) {
          this.useAnchorOpen(res.rawRequest.trim());
          this.alertService.info('Payment on progress. Complete payment in the Telebirr window, then refresh this page.');
        } else {
          this.telebirrPayingBillRef = null;
          this.alertService.error('Could not start Telebirr payment. Please try again.');
        }
      },
      err => {
        this.spinner.hide();
        this.telebirrPayingBillRef = null;
        this.alertService.error(this.errorHandlerService.handleApiError(err));
      }
    );
  }

  useAnchorOpen(link: string) {
    let anchorEle = document.createElement('a');
    anchorEle.setAttribute('href', link);
    anchorEle.setAttribute('target', '_blank');
    anchorEle.setAttribute('rel', 'external');
    anchorEle.style.display = 'none';
    anchorEle.click();
  }

  loadPaymentAmountForWithdrawnEdit() {
    this.appService.getFirstTimeFee(1, this.appDetail.facility.facilityTypeID, this.appDetail.productTypeID).subscribe(resp => {
      this.paymentAmount = resp.data;
    });
  }

  applyPaymentMethodToPaymentInfo() {
    const existingPaymentInfo = this.appDetail?.paymentInfos?.length
      ? this.appDetail.paymentInfos[this.appDetail.paymentInfos.length - 1]
      : null;
    const method = this.applicationForm.value.paymentMethod.method;

    if (!this.paymentInfo) {
      this.paymentInfo = new PaymentInfo({});
    }

    if (existingPaymentInfo?.id) {
      this.paymentInfo.id = existingPaymentInfo.id;
      this.paymentInfo.applicationID = existingPaymentInfo.applicationID;
    }

    if (method === 'CASH') {
      this.paymentInfo.payment = this.paymentInfo.payment || {};
      this.paymentInfo.payment.ServiceProvider = method;
      if (this.applicationForm.get('payment')) {
        this.paymentInfo.recieptNumber = this.applicationForm.value.payment.receiptNumber;
      } else if (existingPaymentInfo?.recieptNumber && existingPaymentInfo.recieptNumber !== 'PAYMENT_PENDING') {
        this.paymentInfo.recieptNumber = existingPaymentInfo.recieptNumber;
      }
      if (this.paymentAmount) {
        this.paymentInfo.payment.Amount = this.paymentAmount;
      }
    } else {
      this.paymentInfo.recieptNumber = 'PAYMENT_PENDING';
      this.paymentInfo.payment = { ServiceProvider: method };
      if (this.paymentAmount) {
        this.paymentInfo.payment.Amount = this.paymentAmount;
      }
    }
  }
}
